"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmbedPresetByKey = exports.embedUrlMatchesPreset = exports.embedPresets = exports.PresetCategory = void 0;
var Airtable_svg_1 = __importDefault(require("@ClientAssets/icons/embed-presets/Airtable.svg"));
var Asana_svg_1 = __importDefault(require("@ClientAssets/icons/embed-presets/Asana.svg"));
var Calendly_svg_1 = __importDefault(require("@ClientAssets/icons/embed-presets/Calendly.svg"));
var ClickUp_svg_1 = __importDefault(require("@ClientAssets/icons/embed-presets/ClickUp.svg"));
var Excel_svg_1 = __importDefault(require("@ClientAssets/icons/embed-presets/Excel.svg"));
var Flourish_svg_1 = __importDefault(require("@ClientAssets/icons/embed-presets/Flourish.svg"));
var Google_Calendar_svg_1 = __importDefault(require("@ClientAssets/icons/embed-presets/Google-Calendar.svg"));
var Google_Docs_svg_1 = __importDefault(require("@ClientAssets/icons/embed-presets/Google-Docs.svg"));
var Google_Forms_svg_1 = __importDefault(require("@ClientAssets/icons/embed-presets/Google-Forms.svg"));
var Google_Sheets_svg_1 = __importDefault(require("@ClientAssets/icons/embed-presets/Google-Sheets.svg"));
var Google_Slides_svg_1 = __importDefault(require("@ClientAssets/icons/embed-presets/Google-Slides.svg"));
var HubSpot_svg_1 = __importDefault(require("@ClientAssets/icons/embed-presets/HubSpot.svg"));
var Iframe_svg_1 = __importDefault(require("@ClientAssets/icons/embed-presets/Iframe.svg"));
var Infogram_svg_1 = __importDefault(require("@ClientAssets/icons/embed-presets/Infogram.svg"));
var Loom_svg_1 = __importDefault(require("@ClientAssets/icons/embed-presets/Loom.svg"));
var Microsoft_Forms_svg_1 = __importDefault(require("@ClientAssets/icons/embed-presets/Microsoft-Forms.svg"));
var Miro_svg_1 = __importDefault(require("@ClientAssets/icons/embed-presets/Miro.svg"));
var Monday_svg_1 = __importDefault(require("@ClientAssets/icons/embed-presets/Monday.svg"));
var OneDrive_svg_1 = __importDefault(require("@ClientAssets/icons/embed-presets/OneDrive.svg"));
var Outlook_svg_1 = __importDefault(require("@ClientAssets/icons/embed-presets/Outlook.svg"));
var Paperform_svg_1 = __importDefault(require("@ClientAssets/icons/embed-presets/Paperform.svg"));
var PowerBI_svg_1 = __importDefault(require("@ClientAssets/icons/embed-presets/PowerBI.svg"));
var Powerpoint_svg_1 = __importDefault(require("@ClientAssets/icons/embed-presets/Powerpoint.svg"));
var Prezi_svg_1 = __importDefault(require("@ClientAssets/icons/embed-presets/Prezi.svg"));
var Slideshare_svg_1 = __importDefault(require("@ClientAssets/icons/embed-presets/Slideshare.svg"));
var Typeform_svg_1 = __importDefault(require("@ClientAssets/icons/embed-presets/Typeform.svg"));
var Vimeo_svg_1 = __importDefault(require("@ClientAssets/icons/embed-presets/Vimeo.svg"));
var Website_svg_1 = __importDefault(require("@ClientAssets/icons/embed-presets/Website.svg"));
var Word_svg_1 = __importDefault(require("@ClientAssets/icons/embed-presets/Word.svg"));
var Youtube_svg_1 = __importDefault(require("@ClientAssets/icons/embed-presets/Youtube.svg"));
var PresetCategory;
(function (PresetCategory) {
    PresetCategory["Forms"] = "Forms";
    PresetCategory["Meetings"] = "Meetings";
    PresetCategory["Presentation"] = "Presentation";
    PresetCategory["ImageAndVideo"] = "Image & video";
    PresetCategory["PlanAndTasks"] = "Plan & tasks";
    PresetCategory["Communication"] = "Communication";
    PresetCategory["Documents"] = "Documents";
    PresetCategory["Other"] = "Other";
})(PresetCategory || (exports.PresetCategory = PresetCategory = {}));
exports.embedPresets = [
    {
        name: "HubSpot Forms",
        category: PresetCategory.Forms,
        iconPath: HubSpot_svg_1.default,
        key: "hubspot-forms",
        validators: ["share.hsforms.com/"],
        instructions: "https://knowledge.hubspot.com/forms/how-can-i-share-a-hubspot-form-if-im-using-an-external-site",
    },
    {
        name: "Office Forms",
        category: PresetCategory.Forms,
        iconPath: Microsoft_Forms_svg_1.default,
        key: "office-forms",
        validators: ["forms.office.com/Pages/ResponsePage.aspx", "forms.office.com/r/"],
        instructions: "https://support.microsoft.com/en-us/office/embed-a-form-in-a-sway-b746cae9-0225-47ca-972c-bc899ec2a475",
    },
    {
        name: "Google Forms",
        category: PresetCategory.Forms,
        iconPath: Google_Forms_svg_1.default,
        key: "google-forms",
        validators: ["docs.google.com/forms", "forms.gle"],
        instructions: "https://help.qwilr.com/article/322-embedding-google-forms",
    },
    {
        name: "Typeform",
        category: PresetCategory.Forms,
        iconPath: Typeform_svg_1.default,
        key: "typeform",
        validators: [".typeform.com/to/"],
        instructions: "https://help.qwilr.com/article/171-embedding-typeform",
    },
    {
        name: "Monday.com Form",
        category: PresetCategory.Forms,
        iconPath: Monday_svg_1.default,
        key: "monday-form",
        validators: ["forms.monday.com/forms/embed/"],
        instructions: "https://support.monday.com/hc/en-us/articles/360000358700-All-about-monday-WorkForms#share_your_workform",
    },
    {
        name: "Paperform",
        category: PresetCategory.Forms,
        iconPath: Paperform_svg_1.default,
        key: "paperform",
        validators: [".paperform.co"],
        instructions: "https://help.qwilr.com/article/324-embedding-a-paperform",
    },
    {
        name: "Calendly",
        category: PresetCategory.Meetings,
        iconPath: Calendly_svg_1.default,
        key: "calendly",
        validators: ["calendly.com/"],
        instructions: "https://help.qwilr.com/article/318-embedding-your-calendly-calendar",
    },
    {
        name: "HubSpot Meeting",
        category: PresetCategory.Meetings,
        iconPath: HubSpot_svg_1.default,
        key: "hubspot-meeting",
        validators: ["meetings.hubspot.com/"],
        instructions: "https://knowledge.hubspot.com/meetings-tool/embed-the-meeting-widget-on-a-page",
    },
    {
        name: "Outlook Calendar",
        category: PresetCategory.Meetings,
        iconPath: Outlook_svg_1.default,
        key: "outlook-calendar",
        validators: true,
        instructions: "https://help.qwilr.com/article/684-iframe-embeds",
    },
    {
        name: "Google Calendar",
        category: PresetCategory.Meetings,
        iconPath: Google_Calendar_svg_1.default,
        key: "google-calendar",
        validators: ["calendar.google.com/calendar/embed?src="],
        instructions: "https://support.google.com/calendar/answer/41207?hl=en",
    },
    {
        name: "Prezi",
        category: PresetCategory.Presentation,
        iconPath: Prezi_svg_1.default,
        key: "prezi",
        validators: ["prezi.com/p/embed/"],
        instructions: "https://help.qwilr.com/article/317-embedding-a-prezi-presentation",
    },
    {
        name: "Google Slides",
        category: PresetCategory.Presentation,
        iconPath: Google_Slides_svg_1.default,
        key: "google-slides",
        validators: ["docs.google.com/presentation/"],
        instructions: "https://help.qwilr.com/article/333-embedding-google-slides",
    },
    {
        name: "Powerpoint",
        category: PresetCategory.Presentation,
        iconPath: Powerpoint_svg_1.default,
        key: "powerpoint",
        validators: ["onedrive.live.com/embed"],
        instructions: "hhttps://support.microsoft.com/en-au/office/embed-a-presentation-in-a-web-page-or-blog-19668a1d-2299-4af3-91e1-ae57af723a60#:~:text=Open%20your%20presentation%20in%20PowerPoint,Share%2C%20and%20then%20click%20Embed.&text=In%20the%20Embed%20box%2C%20under,Copy%2C%20and%20then%20click%20Close",
    },
    {
        name: "Slideshare",
        category: PresetCategory.Presentation,
        iconPath: Slideshare_svg_1.default,
        key: "slideshare",
        validators: ["slideshare.net/slideshow/embed_code/key/"],
        instructions: "https://help.qwilr.com/article/323-embedding-a-slideshare-presentation",
    },
    {
        name: "Miro",
        category: PresetCategory.ImageAndVideo,
        iconPath: Miro_svg_1.default,
        key: "miro",
        validators: ["miro.com/app/live-embed/", "miro.com/app/embed/"],
        instructions: "https://help.miro.com/hc/en-us/articles/360016335640-How-to-embed-Miro-boards-#h_01HB8N4HRB0RC9W3GVZ9JEX510",
    },
    {
        name: "Vimeo",
        category: PresetCategory.ImageAndVideo,
        iconPath: Vimeo_svg_1.default,
        key: "vimeo",
        validators: ["player.vimeo.com/video"],
        instructions: "https://help.qwilr.com/article/180-using-video-blocks#retrieve",
    },
    {
        name: "Youtube",
        category: PresetCategory.ImageAndVideo,
        iconPath: Youtube_svg_1.default,
        key: "youtube",
        validators: ["youtube.com/embed"],
        instructions: "https://help.qwilr.com/article/180-using-video-blocks#retrieve",
    },
    {
        name: "Loom",
        category: PresetCategory.ImageAndVideo,
        iconPath: Loom_svg_1.default,
        key: "loom",
        validators: ["loom.com/embed/"],
        instructions: "https://help.qwilr.com/article/180-using-video-blocks#retrieve",
    },
    {
        name: "Monday.com",
        category: PresetCategory.PlanAndTasks,
        iconPath: Monday_svg_1.default,
        key: "monday-tasks",
        validators: ["view.monday.com/"],
        instructions: "https://support.monday.com/hc/en-us/articles/360000358700-All-about-monday-WorkForms#share_your_workform",
    },
    {
        name: "Asana",
        category: PresetCategory.Forms,
        iconPath: Asana_svg_1.default,
        key: "asana-form",
        validators: ["form.asana.com"],
        instructions: "https://help.asana.com/hc/en-us/articles/14111033233947-Forms#gl-embedding-forms",
    },
    {
        name: "Clickup",
        category: PresetCategory.Forms,
        iconPath: ClickUp_svg_1.default,
        key: "clickup-form",
        validators: ["forms.clickup.com"],
        instructions: "https://help.clickup.com/hc/en-us/articles/7255560049815-Share-embed-and-export-Forms",
    },
    {
        name: "Google Docs",
        category: PresetCategory.Documents,
        iconPath: Google_Docs_svg_1.default,
        key: "google-docs",
        validators: ["docs.google.com/document/d/e/"],
        instructions: "https://help.qwilr.com/article/169-embed-google-docs",
    },
    {
        name: "Microsoft Word",
        category: PresetCategory.Documents,
        iconPath: Word_svg_1.default,
        key: "microsoft-word",
        validators: ["onedrive.live.com/embed"],
        instructions: "https://support.microsoft.com/en-us/office/embed-a-word-document-in-your-blog-0faa0253-2751-44bf-8486-ea7837fe7db1",
    },
    {
        name: "Google Sheets",
        category: PresetCategory.Documents,
        iconPath: Google_Sheets_svg_1.default,
        key: "google-sheets",
        validators: ["docs.google.com/spreadsheets/d/e/"],
        instructions: "https://help.qwilr.com/article/172-embedding-google-sheets",
    },
    {
        name: "Microsoft Excel",
        category: PresetCategory.Documents,
        iconPath: Excel_svg_1.default,
        key: "microsoft-excel",
        validators: ["onedrive.live.com/embed"],
        instructions: "https://support.microsoft.com/en-us/office/share-it-embed-an-excel-workbook-on-your-web-page-or-blog-from-onedrive-804e1845-5662-487e-9b38-f96307144081",
    },
    {
        name: "Airtable",
        category: PresetCategory.Documents,
        iconPath: Airtable_svg_1.default,
        key: "airtable",
        validators: ["airtable.com/embed/"],
        instructions: "https://support.airtable.com/docs/embedding-airtable-views",
    },
    {
        name: "Infogram",
        category: PresetCategory.Documents,
        iconPath: Infogram_svg_1.default,
        key: "infogram",
        validators: ["infogram.com"],
        instructions: "https://help.qwilr.com/article/326-embedding-an-infogram",
    },
    {
        name: "Onedrive",
        category: PresetCategory.Documents,
        iconPath: OneDrive_svg_1.default,
        key: "ms-onedrive",
        validators: ["onedrive.live.com/embed"],
        instructions: "https://support.microsoft.com/en-us/office/embed-files-directly-into-your-website-or-blog-ed07dd52-8bdb-431d-96a5-cbe8a80b7418",
    },
    {
        name: "Flourish",
        category: PresetCategory.Documents,
        iconPath: Flourish_svg_1.default,
        key: "flourish",
        validators: ["flo.uri.sh/visualisation/"],
        instructions: "https://help.flourish.studio/article/145-how-to-embed-flourish-charts-in-your-cms",
    },
    {
        name: "PowerBI",
        category: PresetCategory.Documents,
        iconPath: PowerBI_svg_1.default,
        key: "power-bi",
        validators: true,
        instructions: "https://learn.microsoft.com/en-us/power-bi/collaborate-share/service-embed-secure",
    },
    {
        name: "Iframe",
        category: PresetCategory.Other,
        iconPath: Iframe_svg_1.default,
        key: "iframe",
        validators: true,
        instructions: "https://help.qwilr.com/article/684-iframe-embeds",
    },
    {
        name: "Website",
        category: PresetCategory.Other,
        iconPath: Website_svg_1.default,
        key: "website",
        validators: true,
        instructions: "https://help.qwilr.com/article/684-iframe-embeds",
    },
];
var embedUrlMatchesPreset = function (embedUrl, presetKey) {
    var preset = exports.embedPresets.find(function (f) { return f.key === presetKey; });
    if (!preset) {
        throw new Error("No preset validator registered for preset: ".concat(presetKey));
    }
    if (typeof preset.validators === "boolean") {
        return true;
    }
    return !!preset.validators.find(function (validatorSubstr) { return embedUrl.includes(validatorSubstr); });
};
exports.embedUrlMatchesPreset = embedUrlMatchesPreset;
var getEmbedPresetByKey = function (str) {
    return exports.embedPresets.find(function (preset) { return preset.key === str; });
};
exports.getEmbedPresetByKey = getEmbedPresetByKey;
